import { useState } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { fr, de } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const localToday = () => format(new Date(), "yyyy-MM-dd");
const parseIso = (s) => (s ? new Date(`${s}T12:00:00`) : undefined);
export const fmtCH = (s) => (s ? format(parseIso(s), "dd.MM.yyyy") : "");

export default function DateField({ value, onChange, maxToday = false, minTomorrow = false, autoOpen = false, placeholder = "JJ.MM.AAAA", testId }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(autoOpen);
  const locale = i18n.language?.startsWith("de") ? de : fr;
  const selected = parseIso(value);
  const tomorrow = new Date(); tomorrow.setHours(0, 0, 0, 0); tomorrow.setDate(tomorrow.getDate() + 1);
  const disabled = maxToday ? { after: new Date() } : minTomorrow ? { before: tomorrow } : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} className="input-c text-sm flex items-center gap-2 text-left">
          <CalendarDays className="w-4 h-4 text-primary-c shrink-0" />
          <span className={value ? "" : "text-text-secondary"}>{value ? fmtCH(value) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="z-[80] w-auto p-0" align="start" data-testid={testId ? `${testId}-calendar` : undefined}>
        <Calendar
          mode="single"
          locale={locale}
          weekStartsOn={1}
          selected={selected}
          defaultMonth={selected}
          disabled={disabled}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
